<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <h5>IRREGULARIDADES</h5>
            </b-card-header>
            <b-card-body>
                <app-tabela
                    :itens="irregularidades"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                >

                    <template slot="ativa" slot-scope="data">
                        <app-status
                            :status="data.ativa ? 'SIM' : 'NÃO'"
                        ></app-status>
                    </template>
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <btn-inserir
                                @obterIrregularidadesAtualizadas="obterIrregularidades()"
                            ></btn-inserir>
                        </b-button-group>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <btn-atualizar
                            :irregularidade="data"
                            @obterIrregularidadesAtualizadas="obterIrregularidades()"
                        ></btn-atualizar>
                        <btn-ativar-desativar
                            @obterIrregularidadesAtualizadas="obterIrregularidades()"
                            :irregularidade="data">
                        </btn-ativar-desativar>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import IrregularidadesServicos from './IrregularidadesServicos'
import BtnInserir from './BtnInserir'
import BtnAtualizar from './BtnAtualizar'
import BtnAtivarDesativar from './BtnAtivarDesativar'

export default {
    components: {
        BtnInserir,
        BtnAtualizar,
        BtnAtivarDesativar
    },

    data() {
        return {
            irregularidades: [],
            irregularidade: {},
            campos: [
                {
                    key: 'descricao',
                    label: 'Descrição',
                    filterable: true,
                    sortable: true,
                },
                {
                    key: 'gradacao',
                    label: 'Gradação',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'diasParaCorrecao',
                    label: 'Dias Para Correção',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'ativa',
                    label: 'Ativa',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },

    methods: {
        obterIrregularidades() {
            this.$store.dispatch('addRequest')
            IrregularidadesServicos.obterTodos().then(response => {
                if (response) {
                    if (response.success) {
                        this.irregularidades = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter irregularidades',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {
        this.obterIrregularidades()
    },

    computed: {
    },

    watch: {}
}
</script>
